var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-slide" }, [
    _c(
      "a",
      { attrs: { href: _vm.url, "data-element-id": _vm.getDataElementId } },
      [
        _c("img", {
          staticClass: "slide__image",
          attrs: {
            src: _vm.image,
            alt: _vm.title,
            "data-element-id": _vm.getDataElementId,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "slide__title" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }